var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportDetailReason = function SvgReportDetailReason(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 1 0 7 7 7.01 7.01 0 0 0-7-7m0 13.012A6.012 6.012 0 1 1 14.012 8 6.02 6.02 0 0 1 8 14.012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.157 3.752a2.46 2.46 0 0 0-1.852.667 2.48 2.48 0 0 0-.776 1.804.494.494 0 0 0 .989 0A1.486 1.486 0 0 1 8.1 4.74c.74.057 1.327.646 1.382 1.386a1.48 1.48 0 0 1-.73 1.38 2.55 2.55 0 0 0-1.246 2.196v.312a.494.494 0 0 0 .988 0v-.312a1.56 1.56 0 0 1 .758-1.345 2.476 2.476 0 0 0-1.095-4.605M7.595 11.682a.57.57 0 1 0 1.14 0 .57.57 0 0 0-1.14 0"
  }))));
};
export default SvgReportDetailReason;